import React from "react";

import { CannyAuthService } from "./services/CannyAuth.service";
import CannyAuthPageView from "./views/CannyAuthPageView";
import dependencyInjection from "../../../common/util/dependencyInjection";

interface Services {
  cannyAuthService: CannyAuthService;
}

const cannyAuthService = new CannyAuthService();

const [CannyAuthDependencyProvider, useCannyAuthDeps] = dependencyInjection<Services>({
  services: {
    cannyAuthService,
  },
});

export function CannyAuthPage(): JSX.Element {
  return (
    <CannyAuthDependencyProvider>
      <CannyAuthPageView />
    </CannyAuthDependencyProvider>
  );
}

export { useCannyAuthDeps };
